{
  "name": "hcp-onboarding",
  "version": "4.1.75",
  "scripts": {
    "ng": "ng",
    "build_production": "ng build --optimization --aot --configuration production && npm run sentry:sourcemaps",
    "build_sandbox": "ng build --optimization --aot --configuration test",
    "build_staging": "ng build --optimization --aot --configuration staging && npm run sentry:sourcemaps",
    "build_training": "ng build --optimization --aot --configuration training",
    "check:dep": "npx depcheck",
    "lint-fix": "ng lint --fix",
    "prebuild": "npm --no-git-tag-version version patch",
    "prebuild_production": "npm --no-git-tag-version version patch",
    "prebuild_staging": "npm --no-git-tag-version version patch",
    "prebuild_training": "npm --no-git-tag-version version patch",
    "precommit": "lint-staged",
    "prettier:check": "prettier --check **/**/*.{json,css,js,yml,yaml,md}",
    "prettier:format": "npx prettier --write .",
    "start": "ng serve",
    "test": "ng test",
    "test:prod": "ng build && http-server -c-1 dist/",
    "watch": "ng build --watch --configuration development",
    "build:tailwind": "npx tailwindcss -c ./tailwind.config.js -i ./public/css/tailwind.css -o ./public/css/tailwind.out.css --watch",
    "lint": "ng lint",
    "prepare": "husky",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org kimbocare --project healthcare-provider ./dist/browser && sentry-cli sourcemaps upload --org kimbocare --project healthcare-provider ./dist/browser"
  },
  "lint-staged": {
    "*.{js,ts,tsx}": [
      "npx eslint",
      "npm run prettier:format"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.4",
    "@angular/cdk": "^19.2.7",
    "@angular/common": "^19.2.4",
    "@angular/compiler": "^19.2.4",
    "@angular/core": "^19.2.4",
    "@angular/forms": "^19.2.4",
    "@angular/material": "^19.2.7",
    "@angular/platform-browser": "^19.2.4",
    "@angular/platform-browser-dynamic": "^19.2.4",
    "@angular/router": "^19.2.4",
    "@angular/service-worker": "^19.2.4",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@kimbocare/core": "^0.3.54",
    "@kimbocare/ui": "^0.4.12",
    "@kurkle/color": "^0.3.2",
    "@meddv/ngx-pinch-zoom": "^19.0.0",
    "@ngrx/component-store": "^19.0.1",
    "@ngrx/data": "^19.0.1",
    "@ngrx/effects": "^19.0.1",
    "@ngrx/entity": "^19.0.1",
    "@ngrx/router-store": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@ngrx/store-devtools": "^19.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@sentry/angular": "^10.11.0",
    "@sentry/cli": "^2.53.0",
    "chart.js": "^4.4.3",
    "crypto-js": "^4.2.0",
    "email-validator": "^2.0.4",
    "eslint": "^9.21.0",
    "google-libphonenumber": "^3.2.38",
    "moment": "^2.30.1",
    "ng-inline-svg-2": "^19.0.0",
    "ngrx-store-localstorage": "^19.0.0",
    "ngx-extended-pdf-viewer": "^22.3.9",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-lottie": "^13.0.1",
    "ngx-mask": "^19.0.6",
    "ngx-material-timepicker": "^13.1.1",
    "ngx-owl-carousel-o": "^19.0.0",
    "ngx-scrollbar": "^18.0.0",
    "ngx-toastr": "^19.0.0",
    "ngx-translate-multi-http-loader": "^19.0.2",
    "ngx-webcam": "^0.4.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.5",
    "@angular/cli": "^19.2.5",
    "@angular/compiler-cli": "^19.2.4",
    "@types/express": "^4.17.17",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "sass": "^1.77.8",
    "sass-loader": "^13.2.0",
    "source-map-explorer": "^2.5.3",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.5.2"
  }
}
